<div class="error-container">
  <h1 class="error-code" i18n="@@pages.systemError.title.main">500</h1>
  <h2 class="error-title" i18n="@@pages.systemError.title.secondary">システムエラー</h2>
  <p class="error-message" i18n="@@pages.systemError.message.error">
    システムエラーが発生しました。<br>
    しばらく時間をおいてから再度お試しください。
  </p>
  <p class="error-hint" i18n="@@pages.systemError.message.contact">
    問題が解決しない場合は、管理者にお問い合わせください。
  </p>

  <div class="actions">
    <a routerLink="/" class="button button--primary" i18n="@@pages.systemError.button.backToLogin">
      ログイン画面に戻る
    </a>
  </div>
</div>
